import { Temporal } from 'temporal-polyfill';
import { LOCAL_TIME } from '../dateFormats';

const ONE_MINUTE = Temporal.Duration.from({ minutes: 1 });
const ONE_HOUR = Temporal.Duration.from({ hours: 1 });
const ONE_DAY = Temporal.Duration.from({ days: 1 });
const THREE_DAYS = Temporal.Duration.from({ days: 3 });

// QUESTION: Do we rename this? Can we make this a more generalised version that doesn't have the `ago` suffix?
// If so, how do we handle the case when we return the full date as it is more than 3 days difference?
export const toRelativeDate = (
    compare: Temporal.Instant,
    locales?: string | string[],
    options?: Intl.DateTimeFormatOptions
): string => {
    const duration = Temporal.Now.instant().since(compare);

    if (Temporal.Duration.compare(duration, ONE_MINUTE) < 0) {
        return `${duration.seconds} seconds ago`;
    }
    if (Temporal.Duration.compare(duration, ONE_HOUR) < 0) {
        const minuteDuration = duration.round({ largestUnit: 'minutes', smallestUnit: 'minute' });
        return `${minuteDuration.minutes} minute${minuteDuration.minutes !== 1 ? 's' : ''} ago`;
    }
    if (Temporal.Duration.compare(duration, ONE_DAY) < 0) {
        const hourDuration = duration.round({ largestUnit: 'hours', smallestUnit: 'hour' });
        return `${hourDuration.hours} hour${hourDuration.hours !== 1 ? 's' : ''} ago`;
    }
    if (Temporal.Duration.compare(duration, THREE_DAYS) < 0) {
        const dayDuration = duration.round({ largestUnit: 'days', smallestUnit: 'day' });
        return `${dayDuration.days} day${dayDuration.days !== 1 ? 's' : ''} ago`;
    }

    return compare.toLocaleString(locales, options || LOCAL_TIME.DATE_TIME_SHORT);
};

// I don't like the name of this function - see above questions
export const toPlainRelativeDate = (
    compare: Temporal.Instant,
    locales?: string | string[],
    options?: Intl.DateTimeFormatOptions
): string => {
    const duration = getDuration(compare);

    if (Temporal.Duration.compare(duration, ONE_MINUTE) < 0) {
        return `${duration.seconds} seconds`;
    }
    if (Temporal.Duration.compare(duration, ONE_HOUR) < 0) {
        const minuteDuration = duration.round({ largestUnit: 'minutes', smallestUnit: 'minute' });
        return `${minuteDuration.minutes} minute${minuteDuration.minutes !== 1 ? 's' : ''}`;
    }
    if (Temporal.Duration.compare(duration, ONE_DAY) < 0) {
        const hourDuration = duration.round({ largestUnit: 'hours', smallestUnit: 'hour' });
        return `${hourDuration.hours} hour${hourDuration.hours !== 1 ? 's' : ''}`;
    }
    if (Temporal.Duration.compare(duration, THREE_DAYS) < 0) {
        const dayDuration = duration.round({ largestUnit: 'days', smallestUnit: 'day' });
        return `${dayDuration.days} day${dayDuration.days !== 1 ? 's' : ''}`;
    }

    return compare.toLocaleString(locales, options || LOCAL_TIME.DATE_TIME_SHORT);
};

const getDuration = (compare: Temporal.Instant): Temporal.Duration => {
    const now = Temporal.Now.instant();
    if (Temporal.Instant.compare(compare, now) < 0) {
        return now.since(compare);
    }
    return now.until(compare);
};

export default toRelativeDate;
